(function () {
  function init(root) {
    var end = new Date(root.dataset.end.replace(/([+-]\d\d)(\d\d)$/, '$1:$2')).getTime();
    if (!end) return;
    var els = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { els[k] = root.querySelector('[data-t="' + k + '"]'); });
    var clock = root.querySelector('[data-timer-clock]');
    var endText = root.querySelector('[data-timer-end]');
    var label = root.querySelector('.pdp-timer__label');
    var interval;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(interval);
        if (endText.textContent.trim() && root.dataset.hideOnEnd !== 'true') {
          clock.hidden = true;
          label.hidden = true;
          endText.hidden = false;
        } else {
          root.hidden = true;
        }
        return;
      }
      var s = Math.floor(diff / 1000);
      els.d.textContent = pad(Math.floor(s / 86400));
      els.h.textContent = pad(Math.floor((s % 86400) / 3600));
      els.m.textContent = pad(Math.floor((s % 3600) / 60));
      els.s.textContent = pad(s % 60);
    }

    tick();
    root.classList.add('is-ready');
    interval = setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-pdp-timer]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pdp-timer]').forEach(init);
  });
})();
